import { LOADING } from "../../../constants/constant";
import {
    GET_LIST_OF_AGGREGATOR,
    GET_LIST_OF_AGGREGATOR_SUCCESS,
    GET_LIST_OF_AGGREGATOR_FAILED,
    GET_LIST_OF_AGGREGATOR_RESET
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function getListOfAggregatorReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LIST_OF_AGGREGATOR: {
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;
    }

    case GET_LIST_OF_AGGREGATOR_SUCCESS: {
      let userRes = Object.assign({}, state);
      // console.log(
      //   "getListOfAggregatorReducer => Case => Success: while getting aggregator list: " +
      //     JSON.stringify(action.data.data)
      // );
      userRes.status = action.data.statusMessage;
      userRes.statusCode = action.data.statusCode;
      userRes.isLoading = false;
      //   userRes.statusCode = action.data.status;
      userRes.botList = action.data.data;

      return userRes;
    }
    case GET_LIST_OF_AGGREGATOR_FAILED: {
      console.error(
        "getListOfAggregatorBotsReducer => Case => Error: while getting aggregator list list: " +
          JSON.stringify(action.error)
      );
      return Object.assign({}, state, action.error);
    }

    case GET_LIST_OF_AGGREGATOR_RESET: {
      return initialState;
    }

    default:
      return state;
  }
}
